import dayjs from 'dayjs';
import { jwtDecode } from 'jwt-decode';

const decodeTokenPayload = (token) => {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

export const getTokenExpirationDate = (token) => {
  const payload = decodeTokenPayload(token);
  if (!payload?.exp) {
    return null;
  }
  const expiration = new Date(payload.exp * 1000);
  return expiration;
};

export const getTokenExpirationDateWithFallback = (
  token,
  fallbackHours = 6,
) => {
  const payload = decodeTokenPayload(token);
  if (!payload) {
    return { isValid: false, expiration: null };
  }

  let expiration = payload.exp ? new Date(payload.exp * 1000) : null;
  if (!expiration || expiration.getFullYear() < 2000) {
    expiration = dayjs().add(fallbackHours, 'hour').toDate();
  }

  return { isValid: true, expiration };
};
